module.exports = __webpack_public_path__ + "static/media/mapa_mobile.7f5d73eb.png";